module.exports = __webpack_public_path__ + "media/images/pc/banner/hokepon_via_ad-9af1672cf443099a1e3c9e19587421b8.png";